import { Injectable } from '@angular/core';
import { getSupabase, isSupabaseConfigured } from '../firebase';
import { SupabaseClient } from '@supabase/supabase-js';
import { AppUser, Shift } from '../models/index';

@Injectable({ providedIn: 'root' })
export class ShiftService {
  private supabase: SupabaseClient | null = getSupabase();

  private _toShiftModel(dbData: any): Shift | null {
    if (!dbData) return null;
    return {
      id: dbData.id,
      storeId: dbData.store_id,
      cashierId: dbData.cashier_id,
      status: dbData.status,
      openAmount: dbData.open_amount,
      closeAmount: dbData.close_amount,
      expectedAmount: dbData.expected_amount,
      variance: dbData.variance,
      openedAt: dbData.opened_at,
      closedAt: dbData.closed_at,
      notes: dbData.notes,
    };
  }

  async getOpenShift(cashierId: string): Promise<Shift | null> {
    if (!isSupabaseConfigured() || !this.supabase) {
        return null;
    }
    const { data, error } = await this.supabase.from('shifts').select('*').eq('cashier_id', cashierId).eq('status', 'OPEN').limit(1).single();
    if (error && error.code !== 'PGRST116') throw error;
    return this._toShiftModel(data);
  }

  async openShift(cashier: AppUser, openAmount: number): Promise<Shift> {
    if (!isSupabaseConfigured() || !this.supabase) {
        throw new Error('Database not connected.');
    }
    const { data, error } = await this.supabase.from('shifts').insert({ 
      cashier_id: cashier.uid, 
      store_id: cashier.storeId,
      open_amount: openAmount, 
      status: 'OPEN' 
    }).select().single();
    if (error) throw error;
    return this._toShiftModel(data) as Shift;
  }

  async clockOut(shiftId: string, countedCash: number): Promise<Shift> {
    if (!isSupabaseConfigured() || !this.supabase) {
        throw new Error('Database not connected.');
    }
    const { data, error } = await this.supabase.rpc('close_shift', { p_shift_id: shiftId, p_counted_cash: countedCash });
    if (error) throw error;
    return this._toShiftModel(data) as Shift;
  }
}